module.exports = require('./lib/bind');



//////////////////
// WEBPACK FOOTER
// /home/ubuntu/socialtravel/shared/~/memoize-bind/index.js
// module id = 996
// module chunks = 0